<template>
  <div class="home-container">
    <div class="scroll-content">
      <!-- 2. 顶部 Banner 区域 -->
      <div class="top-banner-wrap" v-if="banners.length > 0">
        <swiper
          :options="bannerSwiperOption"
          class="banner-swiper"
          ref="bannerSwiper"
        >
          <swiper-slide v-for="(v, k) in banners" :key="'banner-' + k">
            <div class="banner-img-container">
              <van-image :src="v.url" fit="cover" class="b-img" />
            </div>
          </swiper-slide>
        </swiper>
      </div>

      <!-- 3. 中部核心 3D 轮动推荐 -->
      <div class="middle">
      <div class="middle-3d-stage" v-if="datalist.length > 0">
        <swiper
          class="movie_swiper_3d"
          :options="movielistSwiperOption"
          ref="movieSwiper"
        >
          <swiper-slide v-for="v in datalist.slice(0, 10)" :key="'3d-' + v.id">
            <div class="card-3d-inner" @click="profile(v.id)">
              <van-image :src="v.img_url" class="c-img" fit="cover">
                <template v-slot:loading>
                  <van-loading type="circular" size="20" />
                </template>
              </van-image>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      </div>

      <!-- 4. 底部标题 -->
      <div class="section-title">당신에게 추천하는</div>

      <!-- 5. 底部两列列表 -->
      <div class="bottom-video-grid">
        <van-pull-refresh v-model="isLoading" success-text="새로고침 성공" @refresh="onRefresh">
          <van-grid :column-num="2" :gutter="12" :border="false">
            <van-grid-item
              v-for="v in datalist.slice(0, 50)"
              :key="'grid-' + v.id"
              @click="profile(v.id)"
            >
              <div class="grid-card" style="width: 100%;">
                <van-image class="game_item_img" :src="v.img_url" fit="cover">
                  <template v-slot:loading>
                    <van-loading type="circular" />
                  </template>
                </van-image>
                <div class="rig-name van-ellipsis" style="width: 155px;">{{ v.xuanfei_name }}</div>
              </div>
            </van-grid-item>
          </van-grid>
        </van-pull-refresh>
      </div>

      <div class="safe-area-bottom"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banners: [],
      isLoading: false,
      datalist: [],

      bannerSwiperOption: {
        loop: true,
        autoplay: { delay: 3000, disableOnInteraction: false },
        observer: true,
        observeParents: true,
        rebuildOnUpdate: true
      },

      movielistSwiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        slidesPerView: 'auto',
        loop: true,
        speed: 600,
        coverflowEffect: {
          spaceBetween: -20,  
          rotate: 0,
          stretch: -70,
          depth: 150,
          modifier: 1,
          slideShadows: false
        }
      }
    };
  },

  computed: {
    displayTitle() {
      return this.$route.query.name || '全部地区';
    }
  },

  methods: {
    back() {
      this.$router.push({ path: 'Choose' });
    },

    profile(id) {
      this.$router.push({
        path: '/profile',
        query: {
          id: id,
          name: this.displayTitle,
          adsid: this.$route.query.id || ''
        }
      });
    },

    async onRefresh() {
      await Promise.all([this.getBasicConfig(), this.getxuanfeilist()]);
    },

    async getBasicConfig() {
      try {
        const res = await this.$http({ method: 'get', url: 'sys_config' });
        this.banners = res.data.banners || [];

        // ✅ 修复 banner 不刷新
        this.$nextTick(() => {
          this.$refs.bannerSwiper?.$swiper?.update();
        });

      } catch (e) {
        console.error(e);
      }
    },

    async getxuanfeilist() {
  this.isLoading = true;
  try {
    const params = this.$route.query.id ? { id: this.$route.query.id } : {};
    const res = await this.$http({
      method: 'get',
      url: 'xuanfeilist',
      params
    });

    // --- 修改部分开始 ---
    // 获取原始数组，如果 res.data 为空则默认为空数组
    const rawData = res.data || [];
    
    // 过滤出 ID 大于 1438 的项
    // 使用 Number() 确保字符串类型的 ID 也能正确比较
    this.datalist = rawData.filter(item => Number(item.id) > 1438);
    // --- 修改部分结束 ---

    // ✅ 修复 3D swiper 不刷新
    this.$nextTick(() => {
      this.$refs.movieSwiper?.$swiper?.update();
    });

  } catch (error) {
    console.error(error); // 打印错误方便调试
    this.$toast("加载失败");
  } finally {
    this.isLoading = false;
  }
}
  },
  async created() {
    this.getBasicConfig();
    this.getxuanfeilist();
  }
};
</script>

<style scoped>
.home-container {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background-color: #000;
  overflow-x: hidden;
  overflow-y: auto;
  background-image: url("/img/page-bg.jpg");
  padding-bottom: 30px;

}

.scroll-content {
  position: relative;
  z-index: 1;
  padding: 20px 0;
}

/* --- 顶部 Banner 优化 --- */
.top-banner-wrap {
  width: 94%;
  margin: 0 auto 20px;
}

.banner-img-container {
  width: 100%;
  height: 350px;
  /* 降低高度，更符合手机 Banner 比例 */
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}

/* --- 中部 3D 轮播优化 (关键点) --- */
.middle {
  height: 100%;
  height: 689px;
  background-image: url("/img/bannerbg.jpg");
  background-size: cover;
}

/* 1. 舞台容器：确保溢出显示，并居中 */
.middle-3d-stage {
  width: 100%;
  padding: 100px 0;
  display: flex;
  justify-content: center; /* 确保 Swiper 容器在页面水平居中 */
  overflow: hidden;        /* 避免侧边溢出产生滚动条 */
}

/* 2. Swiper 容器：宽度不宜过小 */
.movie_swiper_3d {
  width: 100%;             /* 设为100%以允许图片自由定位 */
  max-width: 1200px;       /* 或者设定一个最大宽度 */
  overflow: visible !important; 
}

/* 3. 滑块：控制间隙的核心 */
.movie_swiper_3d .swiper-slide {
  width: 60%;             /* 调小主图宽度比例，能让侧边露出更多 */
  height: 500px;
  background-size: cover;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); /* 更平滑的曲线 */
  
  /* 关键：设置缩放中心，防止侧边缩放后跑得太远 */
  transform-origin: center center; 
  
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 4. 激活态：中间那张图 */
.swiper-slide-active {
  opacity: 1 !important;
  transform: scale(1) !important; /* 原始大小 */
  z-index: 10;                  /* 确保中间图在最前面 */
}

/* 5. 非激活态（侧边图片）：控制间隙 */
.swiper-slide:not(.swiper-slide-active) {
  opacity: 0.6;
  /* 
     通过 scale 控制大小的同时，
     如果想缩短间隙，可以给非激活态添加适当的 translateX 
  */
  transform: scale(0.8); /* 0.55 太小了，建议 0.7-0.8 视觉效果更好 */
  filter: brightness(0.4) blur(1px); /* 增加一点模糊感，突出中心 */
}

/* 如果侧边离得太远，可以利用这个类手动拉近距离 */
.swiper-slide-prev {
  transform: scale(0.8) translateX(15%) !important; /* 向右靠拢 */
}
.swiper-slide-next {
  transform: scale(0.8) translateX(-15%) !important; /* 向左靠拢 */
}

/* 6. 内部卡片 */
.card-3d-inner {
  width: 100%;
  height: 500px;
  border-radius: 15px;
  overflow: hidden;
  background: #1a1a1a;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
}

.game_item_img {
  width: 100%;
  height: 450px;
}

/* --- 底部网格优化 --- */
.section-title {
  margin: 30px 0 15px 15px;
  color: #e2c07d;
  font-size: 18px;
  font-weight: bold;
}

.bottom-video-grid {
  padding: 0 10px;
  z-index: 0;
}



.rig-name {
  width: 100%;
  color: #fff;
  font-size: 14px;
  text-align: center;
  background: #252525;

  /* --- 防止文字溢出的核心代码 --- */
  white-space: nowrap;
  /* 强制不换行 */
  overflow: hidden;
  /* 遮住超出部分 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 (...) */
  display: block;
  /* 确保它是块级元素 */

}

/* --- Vant 样式重置 (解决变形的核心) --- */
::v-deep .van-grid-item__content {
  padding: 0 !important;
  /* 移除内边距 */
  background: transparent !important;
}

::v-deep .van-image__img {
  border-radius: 0;
  /* 让图片填满 card-3d-inner 的圆角 */
  padding: 0 !important;
  /* 彻底移除之前可能导致缩水的 padding */
}

/* 下拉刷新容器背景透明 */
::v-deep .van-pull-refresh {
  background: transparent;
}

/* 修正下拉刷新容器，确保它不遮挡层级 */
::v-deep .van-pull-refresh {
  overflow: visible;
  z-index: 1;
}

/* 文字溢出省略 */
.van-ellipsis {
  white-space: nowrap;
  /* 强制不换行 */
  overflow: hidden;
  /* 遮住超出部分 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 (...) */
  display: block;
  /* 确保它是块级元素 */
}

.safe-area-bottom {
  height: 80px;
}
</style>
